import React from 'react';
import {BlocksControls, InlineTextarea} from 'react-tinacms-inline';
import PropTypes from 'prop-types';
import {usePage} from '../../contexts/PageContext';
import {Content} from '../Common/Content';
import {paragraphTemplate} from '../../constants/templates/paragraph';
import {useBlockProps} from '../../hooks/useBlockProps';
import {box, text} from '../../constants/fields/fields';

function ParagraphComponent({index, data}) {
  const {blockProps} = useBlockProps(data);
  const {language} = usePage();
  return (
    <BlocksControls index={index} focusRing={{offset: 0}}>
      <Content {...blockProps}>
        <InlineTextarea name={`paragraph.${language}`} focusRing={false}/>
      </Content>
    </BlocksControls>
  );
}

const template = {
  label: 'Paragraph',
  defaultItem: paragraphTemplate,
  fields: [
    text,
    box
  ]
};
export const Paragraph = {
  Component: ParagraphComponent,
  template
};

ParagraphComponent.propTypes = {
  data: PropTypes.object,
  index: PropTypes.number
};
